<template>
  <div class="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
    <div class="glass-card rounded-lg p-4 hover-lift">
      <div class="flex items-center justify-between">
        <div>
          <p class="text-gray-400 text-sm">Gesamt</p>
          <p class="text-2xl font-bold text-white">{{ stats.total }}</p>
        </div>
        <div class="text-blue-400">
          <i class="fas fa-users text-2xl"></i>
        </div>
      </div>
    </div>
    
    <div class="glass-card rounded-lg p-4 hover-lift">
      <div class="flex items-center justify-between">
        <div>
          <p class="text-gray-400 text-sm">Eingecheckt</p>
          <p class="text-2xl font-bold text-green-400">{{ stats.checkedIn }}</p>
        </div>
        <div class="text-green-400">
          <i class="fas fa-check-circle text-2xl"></i>
        </div>
      </div>
    </div>
    
    <div class="glass-card rounded-lg p-4 hover-lift">
      <div class="flex items-center justify-between">
        <div>
          <p class="text-gray-400 text-sm">Ausstehend</p>
          <p class="text-2xl font-bold text-yellow-400">{{ stats.pending }}</p>
        </div>
        <div class="text-yellow-400">
          <i class="fas fa-clock text-2xl"></i>
        </div>
      </div>
    </div>
    
    <div class="glass-card rounded-lg p-4 hover-lift">
      <div class="flex items-center justify-between">
        <div>
          <p class="text-gray-400 text-sm">Check-in Rate</p>
          <p class="text-2xl font-bold text-fvv-orange">{{ stats.percentage }}%</p>
        </div>
        <div class="text-fvv-orange">
          <i class="fas fa-chart-pie text-2xl"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StatsCards',
  props: {
    stats: {
      type: Object,
      required: true
    }
  }
}
</script>
